
<script>
import { Line } from "vue-chartjs";
import axios from 'axios'

export default {
  extends: Line,
  dataline1: [],
  // dataline2: [],
  data() {
    return {
      localhost:'https://guide.artnaji.com/index.php/api',
      // localhost:'http://localhost:8000/api',
      request:{}
    }
  },
  mounted() {
    this.request={
      year:new Date().getFullYear()
    }
       axios.post(this.localhost+"/sales/chrtrender",{year:this.request.year}
      //  ,{
    //       headers:{
    //         'Authorization': 'Bearer '+localStorage.getItem('user-token')
    //       }
    // }
        ).then(response => {
            this.dataline1=[response.data[0]['1'][0],response.data[1]['2'][0],response.data[2]['3'][0],response.data[3]['4'][0],response.data[4]['5'][0],response.data[5]['6'][0],response.data[6]['7'][0],response.data[7]['8'][0],response.data[8]['9'][0],response.data[9]['10'][0],response.data[10]['11'][0],response.data[11]['12'][0]]
            // this.dataline2=[response.data[0]['1'][1],response.data[1]['2'][1],response.data[2]['3'][1],response.data[3]['4'][1],response.data[4]['5'][1],response.data[5]['6'][1],response.data[6]['7'][1],response.data[7]['8'][1],response.data[8]['9'][1],response.data[9]['10'][1],response.data[10]['11'][1],response.data[11]['12'][1]]
    this.renderChart(
      {
        labels: [
          "Janvier",
          "Février",
          "Mars",
          "Avril",
          "Mai",
          "Juin",
          "Juillet",
          "Août", 
          "Septembre",
          "Octobre",
          "Novembre",
          "Décembre",
        ],

        datasets: [
          {
            label: "chiffres D'affaire",
            data: this.dataline1,
            backgroundColor: "transparent",
            borderColor: "rgba(1, 116, 188, 0.50)",
            pointBackgroundColor: "rgba(1, 116, 188, 0.50)",
          }
          // ,
          //  {
          //   label: "Les charges",
          //   data: this.dataline2,
          //   backgroundColor: "transparent",
          //   borderColor: "purple",
          //   pointBackgroundColor: "purple",
          // }
        ],
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: "CA/Mois",
        },
      }
    );
    })
  },
};
</script>
